// import { iFacadeConfig } from '@andbank-myinvestor/arq/lib/basic-operation';
// import { config as authConfig } from './auth-config';
// /* const token = '0a404791-aab8-402b-a5dc-e0601ecf6f12'; */
// const config: iFacadeConfig['communicationConfig'] = {
// 	host: 'abkt03.azure-api.net',
// 	basepath: '',
// 	protocol: 'https',
// 	timeout: 0,
// 	authConfig: {
// 		authServerLoginUri:
// 			'https://10.21.20.20:8443/auth/realms/MyInvestor/protocol/openid-connect/auth',
// 		authServerTokenUri:
// 			'https://10.21.20.20:8443/auth/realms/MyInvestor/protocol/openid-connect/token',
// 		authServerLogoutUri:
// 			'https://10.21.20.20:8443/auth/realms/MyInvestor/protocol/openid-connect/logout',
// 		client_id: 'account-console',
// 		redirect_uri: 'https://localhost:3000',
// 		withState: true,
// 	},
// 	paths: {
// 		userProfiling: {
// 			path: 'userProfiling',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/literales-api/v2',
// 					basepath: 'int/canalcliente/literales-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					basepath: 'int/canalcliente/login-api/v2',
// 					basepath: 'int/canalcliente/login-api/v2',
// 				},
// 			},
// 		},
// 		banners: {
// 			path: 'banners/MY',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/general-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'altaCliente/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		accounts: {
// 			path: 'accounts',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/accounts-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'altaCliente/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		accountCurrencyActivation: {
// 			path: 'accountCurrencyActivation',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/accounts-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		listOffices: {
// 			path: 'listOffices',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/accounts-api/v2',
// 				},
// 			},
// 		},
// 		participantsAccounts: {
// 			path: 'participantsAccounts',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/accounts-api/v2',
// 				},
// 			},
// 		},
// 		cards: {
// 			path: 'cards',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/cards-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'altaCliente/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		comunications: {
// 			path: 'communications',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/general-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					basepath: 'int/canalcliente/communications-api/v2',
// 				},
// 			},
// 		},
// 		reporting: {
// 			path: 'reporting',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/general-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		loans: {
// 			path: 'loans',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/loans-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/general-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		markets: {
// 			path: 'markets',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/markets-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/login-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		sepaCountryISO3: {
// 			path: 'sepaCountryISO3',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		mifid: {
// 			path: 'convenienceTest',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/mifid-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/login-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		savings: {
// 			path: 'savings',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/savings-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/general-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		transfers: {
// 			path: 'transfers',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 				put: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 				delete: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 			},
// 		},
// 		beneficiaries: {
// 			path: 'beneficiaries',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 				put: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 				delete: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 			},
// 		},
// 		language: {
// 			path: 'literales',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/literales-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		configuration: {
// 			path: 'configurations/default',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		login: {
// 			path: 'tokenjwt',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/login-api/v2',
// 				},
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/communications-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		logout: {
// 			path: 'logout',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/communications-api/v2/tasks/',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		authenticate: {
// 			path: 'authenticate',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/communications-api/v2/tasks/',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		contactInformation: {
// 			path: 'contactInformation',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/general-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/communications-api/v2/tasks/',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		refresh: {
// 			path: 'refresh',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/hbk-security-service-api/v2',
// 				},
// 			},
// 		},
// 		home: {
// 			path: 'home',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					basepath: 'int/canalcliente/general-api/v2',
// 				},
// 				put: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		phoneAssignation: {
// 			path: 'PhoneAssignation',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/general-api/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 				put: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 				delete: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investments: {
// 			path: 'investments',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					basepath: 'int/canalcliente/general-api/v2',
// 				},
// 				put: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 				delete: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		updatePreferences: {
// 			path: 'updatePreferences',
// 			verbs: {
// 				post: {
// 					basepath: 'inversiones/v2/basicOperations',
// 				},
// 			},
// 		},
// 		accountStatement: {
// 			path: 'accountStatement',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		ownershipCertificate: {
// 			path: 'ownershipCertificate',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/accounts-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		transfers2FM: {
// 			path: 'transfers2FM',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 				put: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 				delete: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 			},
// 		},
// 		checkIban: {
// 			path: 'dataiban',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 				put: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 				delete: {
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 				},
// 			},
// 		},
// 		beneficiariesTransfers: {
// 			path: 'beneficiaries',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 				put: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 				delete: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		portfolioPG: {
// 			path: '/home/portfolio',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/general-api/v2',
// 				},
// 			},
// 		},
// 		musicalWalletDetail: {
// 			path: 'getMusicalWalletDetail',
// 			verbs: {
// 				get: {
// 					basepath: 'inversiones/v2/basicOperations',
// 				},
// 			},
// 		},
// 		bizumUserInfo: {
// 			path: 'getUserDataBizum',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/users',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumSendPaymentOperation: {
// 			path: 'paymentOperation',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/transfers',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumRequestPaymentOperation: {
// 			path: 'paymentRequest',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/transfers',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		analysisBizum: {
// 			path: 'analysis',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumONGList: {
// 			path: 'list',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/ong',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		entityUserInfo: {
// 			path: 'getUserData',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/users',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumOperationsList: {
// 			path: 'list',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/operations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumCancelOperation: {
// 			path: 'cancelOperation',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/transfers',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumRepaymentOperation: {
// 			path: 'repayment',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/transfers',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumOTPGenerate: {
// 			path: 'generate',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/otp',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumOTPValidate: {
// 			path: 'validate',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/otp',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bizumLogin: {
// 			path: 'login',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/session',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		altaBizumLogin: {
// 			path: 'createUser',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/users',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		bajaBizumLogin: {
// 			path: 'unsubscribeUser',
// 			verbs: {
// 				post: {
// 					basepath: 'bizum/v2/users',
// 				},
// 			},
// 		},
// 		bizumSubscription: {
// 			path: 'suscriptions',
// 			verbs: {
// 				post: {
// 					basepath: 'bizum/v2',
// 				},
// 			},
// 		},
// 		portfolio: {
// 			path: 'portfolios',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'bizum/users',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestCancellation: {
// 			path: 'requestCancellation',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/portfolios',
// 					protocol: 'https',
// 				},
// 				put: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/portfolios',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		getInvestmentOrderList: {
// 			path: 'orderList',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		orderRelatedOperations: {
// 			path: 'orderRelatedOperations',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		walletHireResult: {
// 			path: 'getTest/',
// 			verbs: {
// 				post: {
// 					basepath: 'suitabilityTest',
// 				},
// 			},
// 		},
// 		walletHireDownload: {
// 			path: 'download',
// 			verbs: {
// 				post: {
// 					basepath: 'signContract',
// 				},
// 			},
// 		},
// 		walletProfitability: {
// 			path: 'postProfitabilityMWR',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		walletHireInit: {
// 			path: 'initDigitalSign',
// 			verbs: {
// 				post: {
// 					basepath: 'signContract',
// 				},
// 			},
// 		},
// 		walletHireConfirm: {
// 			path: 'confirmDigitalSign',
// 			verbs: {
// 				post: {
// 					basepath: 'signContract',
// 				},
// 			},
// 		},
// 		investmentDetail: {
// 			path: 'investmentDetail',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentComposition: {
// 			path: 'postPositions',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentCompositionFunds: {
// 			path: "postPositions",
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentChart: {
// 			path: 'postClientGraph',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentFundsList: {
// 			path: 'listar',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/fondos',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentRegionsList: {
// 			path: 'obternerRegiones',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/fondos',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentManagersList: {
// 			path: 'obternerGestoras',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/fondos',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentValidarRad: {
// 			path: 'validarRad',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/fondos',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentAvailable: {
// 			path: 'clients',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		queryIsUserFF: {
// 			path: "isUserFF",
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: "register",
// 					protocol: "https"
// 				},
// 			},
// 		},
// 		contractFundsMYBPDF: {
// 			path: 'generateContractFundsMYB',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		startSignContractFundsMYB: {
// 			path: 'startSignContractFundsMYB',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		contratarFondosMYBPDF: {
// 			path: 'contratar',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/fondos',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		investmentFundsDetail: {
// 			path: 'detallar',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/fondos',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		transferDetailPdf: {
// 			path: 'transferReceiptMYB',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/v2/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		transferDetailResumePdf: {
// 			path: 'transferDetailOverview',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		transfersPdf: {
// 			path: 'transferOverview',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		transfersExcel: {
// 			path: 'exportTransfers',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		transfersMYB: {
// 			path: 'transfersMYB',
// 			verbs: {
// 				put: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		transfersMYB2FM: {
// 			path: 'transfersMYB2FM',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		marketCurrencyMYB: {
// 			path: 'marketCurrencyMYB',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/transfers-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		movementDetailPdf: {
// 			path: 'movementDetailOverview',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		movementsPdf: {
// 			path: 'movementOverview',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		movementsExcel: {
// 			path: 'exportMovements',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		profiling: {
// 			path: 'userProfiling',
// 			verbs: {
// 				get: {},
// 			},
// 		},
// 		radicalAccounts: {
// 			path: 'radicalAccounts',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		suitabilityQuestion: {
// 			path: 'question',
// 			basepath: 'inversiones/suitabilityTest',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				post: {
// 					headers: {
// 						'Content-Type': 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		suitabilityGetResult: {
// 			path: 'getResult',
// 			basepath: 'inversiones/suitabilityTest',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				post: {
// 					headers: {
// 						'Content-Type': 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		suitabilitySetTest: {
// 			path: 'setTest',
// 			basepath: 'inversiones/suitabilityTest',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				post: {
// 					headers: {
// 						'Content-Type': 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		suitabilityGetTest: {
// 			path: 'getTest',
// 			basepath: 'inversiones/suitabilityTest',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				post: {
// 					headers: {
// 						'Content-Type': 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		mifidConvenienceTest: {
// 			path: 'convenienceTest',
// 			basepath: 'int/canalcliente/mifid-api/v2',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				get: {
// 					headers: {
// 						Accept: 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		mifidQuestion: {
// 			path: 'question',
// 			basepath: 'int/canalcliente/mifid-api/v2/convenienceTest',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				get: {
// 					headers: {
// 						Accept: 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		saveMifidQuestion: {
// 			path: 'question2FM',
// 			basepath: 'int/canalcliente/mifid-api/v2/convenienceTest',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				post: {
// 					headers: {
// 						Accept: 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		confirmMifidQuestion: {
// 			path: 'question2FM/confirmation',
// 			basepath: 'int/canalcliente/mifid-api/v2/convenienceTest',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				post: {
// 					// confirm a convenience test
// 					headers: {
// 						Accept: 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		mifidValidation: {
// 			path: 'validation',
// 			basepath: 'int/canalcliente/mifid-api/v2/convenienceTest/question',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				post: {
// 					headers: {
// 						Accept: 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		mifidProduct: {
// 			path: 'product',
// 			basepath: 'convenienceTest',
// 			verbs: {
// 				get: {
// 					headers: {
// 						Accept: 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		mailAttachment: {
// 			path: 'sendMailDocument',
// 			basepath: 'int/canalcliente/ol-mailing/v2',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				post: {
// 					headers: {
// 						Accept: 'application/json',
// 						'Content-Type': 'application/json',
// 					},
// 				},
// 			},
// 		},
// 		sendMailCardInfo: {
// 			path: 'sendMailCardInfo',
// 			basepath: 'int/canalcliente/ol-mailing/v2',
// 			host: 'abkt03.azure-api.net',
// 			protocol: 'https',
// 			verbs: {
// 				get: {
// 					basepath: 'inversiones/v2/basicOperations',
// 				},
// 			},
// 		},
// 		wfg: {
// 			path: 'wfg',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/wfg-api/v2',
// 				},
// 			},
// 		},
// 		changePassword: {
// 			path: 'changeUserPass2FM',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/login-api/v2',
// 				},
// 			},
// 		},
// 		changePasswordOTP: {
// 			path: 'changeUserPassConfirmation2FM',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/login-api/v2',
// 				},
// 			},
// 		},
// 		correspondence: {
// 			path: 'communications',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/communications-api/v2',
// 				},
// 			},
// 		},
// 		getTasksList: {
// 			path: 'getTasksList',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/communications-api/v2/tasks/',
// 				},
// 			},
// 		},
// 		getTasksDetail: {
// 			path: 'getTasksDetail',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/communications-api/v2/tasks/',
// 				},
// 			},
// 		},
// 		getTasksFile: {
// 			path: 'getTasksFile',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/communications-api/v2/tasks/',
// 				},
// 			},
// 		},
// 		bizumUpload: {
// 			path: 'upload',
// 			verbs: {
// 				post: {
// 					basepath: 'bizum/v2/content',
// 				},
// 			},
// 		},
// 		bizumDownload: {
// 			path: 'download',
// 			verbs: {
// 				post: {
// 					basepath: 'bizum/v2/content',
// 				},
// 			},
// 		},
// 		landing: {
// 			path: 'faqs',
// 			host: 'myinvuat.andbank.com',
// 			protocol: 'https',
// 			verbs: {
// 				get: {},
// 			},
// 		},
// 		pendingTasks: {
// 			path: 'getPendingTasks',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/communications-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestCard: {
// 			path: 'cards/application',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestInfoCard: {
// 			path: 'cards',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestMovementsCard: {
// 			path: 'cards',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestLimitsCard: {
// 			path: 'cards/',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		userValid: {
// 			path: 'isUserValid',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'register',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		userUSD: {
// 			path: 'isUserUSD',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'register/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		downloadCard: {
// 			path: 'requestCards/downloadContract',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		initSignContractCard: {
// 			path: 'requestCards/initSignContractCard',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		cardOTP: {
// 			path: 'requestCards/signContractCard',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		cardValidateOTP: {
// 			path: 'requestCards/validateSignContractCard',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		pinCard: {
// 			path: 'requestCards/pin',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		prepareDigitalSignManagedPortfolio: {
// 			path: 'prepareDigitalSignManagedPortfolio',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/signContract',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		initDigitalSign: {
// 			path: 'initDigitalSign',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/signContract',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		confirmDigitalSign: {
// 			path: 'confirmDigitalSign',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/signContract',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		inviteFriend: {
// 			path: 'generateFriendCode',
// 			withAuth: false,
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/altaCliente/v2',
// 				},
// 			},
// 		},
// 		validateBooking: {
// 			path: 'validateBooking',
// 			withAuth: false,
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/altaCliente/v2',
// 				},
// 			},
// 		},
// 		confirmBooking: {
// 			path: 'confirmBooking',
// 			withAuth: false,
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/altaCliente/v2',
// 				},
// 			},
// 		},
// 		startTransfer: {
// 			path: 'startTransfer',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		startTransferValidation: {
// 			path: 'validateTransfer',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		signTransfer: {
// 			path: 'signTransfer',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		startExternalTransfer: {
// 			path: 'requestProvision',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/portfolios',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		startPermanentTransfer: {
// 			path: 'startPermanentTransfer',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		startPermanentTransferValidation: {
// 			path: 'validatePermanentTransfer',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		signPermanentTransfer: {
// 			path: 'signPermanentTransfer',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/basicOperations',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		refundWallet: {
// 			path: 'requestRefund',
// 			verbs: {
// 				post: {
// 					basepath: 'inversiones/v2/portfolios',
// 				},
// 				put: {
// 					basepath: 'inversiones/v2/portfolios',
// 				},
// 			},
// 		},
// 		fichaFondo: {
// 			path: 'getDocument',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones/allfunds',
// 				},
// 			},
// 		},
// 		queryBeneficiaryClient: {
// 			path: 'consultarBeneficioClienteRadical',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones',
// 					protocol: 'https',
// 				},
// 				delete: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones',
// 					protocol: 'https',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones',
// 					protocol: 'https',
// 				},
// 				put: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		saveDocumentIdentity: {
// 			path: 'saveDocumentIdentity',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones',
// 					protocol: 'https',
// 				},
// 				delete: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'inversiones',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		news: {
// 			path: 'news',
// 			host: 'myinvuat.andbank.com',
// 			protocol: 'https',
// 			verbs: {
// 				get: {},
// 			},
// 		},
// 		requestOrderList: {
// 			path: 'orderList',
// 			verbs: {
// 				post: {
// 					basepath: 'inversiones/v2/basicOperations',
// 				},
// 			},
// 		},
// 		requestPendingOrderList: {
// 			path: 'orders',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/savings-api/v2',
// 					protocol: 'https',
// 				},
// 				delete: {
// 					basepath: 'inversiones/v2',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/savings-api/v2',
// 					protocol: 'https',
// 				},
// 				put: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/savings-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestLimitsCards: {
// 			path: "limitsMYB",
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2/cards',
// 					protocol: 'https',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2/cards',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestConfigurationCards: {
// 			path: "configure",
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2/cards',
// 					protocol: 'https',
// 				},
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2/cards',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestGetOtpCancelCard: {
// 			path: "cancel2FM",
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2/cards',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		requestConfirmOtpCancelCard: {
// 			path: "cancelConfirmation2FM",
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/cards-api/v2/cards',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		validateSecondTit: {
// 			path: 'validateSecondTit',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/accounts-api/v2/jointAccounts',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		validateRestrictionActivation: {
// 			path: 'validateRestrictionActivation',
// 			verbs: {
// 				post: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/accounts-api/v2/jointAccounts',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		validateSignatureSign: {
// 			path: 'validateSignatureSign',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/accounts-api/v2/jointAccounts',
// 				},
// 			},
// 		},
// 		createCaseConjunto: {
// 			path: 'createCaseConjunto',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/accounts-api/v2/jointAccounts',
// 				},
// 			},
// 		},
// 		performTaskCC: {
// 			path: 'performTaskCC',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/appian-web-api/v2/api',
// 				},
// 			},
// 		},
// 		deleteCaseConjunto: {
// 			path: 'deleteCaseConjunto',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/appian-web-api/v2/api',
// 				},
// 			},
// 		},
// 		getTaskInfoConjuntas: {
// 			path: 'getTaskInfoConjuntas',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/appian-web-api/v2/api',
// 				},
// 			},
// 		},
// 		getCasesByRadicalPerson: {
// 			path: 'getCasesByRadicalPerson',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/appian-web-api/v2/api',
// 				},
// 			},
// 		},
// 		generateContractsJointAccount: {
// 			path: 'generateContractsJointAccount',
// 			verbs: {
// 				post: {
// 					basepath: 'int/inversiones/v2/basicOperations',
// 				},
// 			},
// 		},
// 		userProfilingConfig: {
// 			path: 'configurations/default',
// 			verbs: {
// 				get: {
// 					host: 'abkt03.azure-api.net',
// 					basepath: 'int/canalcliente/configurations-api/v2',
// 					protocol: 'https',
// 				},
// 			},
// 		},
// 		signatureResetOTP: {
// 			path: 'signatureReset',
// 			verbs: {
// 				post: {
// 					basepath: 'int/canalcliente/accounts-api/v2/jointAccounts',
// 				},
// 			},
// 		},
// 		getContractBase64: {
// 			path: 'getContractBase64',
// 			verbs: {
// 				get: {
// 					basepath: 'int/canalcliente/accounts-api/v2/jointAccounts',
// 				},
// 			},
// 		},
// minorAccounts: {
// 	path: 'minorAccounts',
// 	verbs: {
// 		get: {
// 			basepath: 'int/canalcliente/accounts-api/v2',
// 		}
// 	},
// },
// 	},
// };
// export { config };

// // UAT PARA PODER ACCEDER A BIZUM
import { iFacadeConfig } from '@andbank-myinvestor/arq/lib/basic-operation';
import { config as authConfig } from './auth-config';
/* const token = '0a404791-aab8-402b-a5dc-e0601ecf6f12'; */
const config: iFacadeConfig['communicationConfig'] & {
	promo3legalurl?: Record<string, string>;
} = {
	host: 'abkt03.azure-api.net',
	basepath: '',
	protocol: 'https',
	timeout: 0,
	authConfig: {
		authServerLoginUri:
			'https://ssouat.andbank.com/auth/realms/MyInvestor/protocol/openid-connect/auth',
		authServerTokenUri:
			'https://ssouat.andbank.com/auth/realms/MyInvestor/protocol/openid-connect/token',
		authServerLogoutUri:
			'https://ssouat.andbank.com/auth/realms/MyInvestor/protocol/openid-connect/logout',
		client_id: 'account-console',
		redirect_uri: 'https://localhost:3000',
		withState: true,
	},
	promo3legalurl: {
		ca: 'https://myandbank.com/wp-content/uploads/2026/07/Bases-Campanya-Cte.-Remunerat-3.pdf',
		es: 'https://myandbank.com/wp-content/uploads/2026/07/Bases-Campanya-Cte.-Remunerat-3-ESP.pdf',
		en: 'https://myandbank.com/wp-content/uploads/2026/07/Bases-Campanya-Cte.-Remunerat-3-ENG.pdf',
		fr: 'https://myandbank.com/wp-content/uploads/2026/07/Bases-Campanya-Cte.-Remunerat-3-FRA.pdf',
	},
	paths: {
		userProfiling: {
			path: 'userProfiling',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/login-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/login-api/v2',
				},
			},
		},
		userProfilingConfig: {
			path: 'configurations/default',
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/configurations-api/v2',
					protocol: 'https',
				},
			},
		},
		banners: {
			path: 'banners/MY',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
			},
		},
		accounts: {
			path: 'accounts',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		listOffices: {
			path: 'listOffices',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		participantsAccounts: {
			path: 'participantsAccounts',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		accountRemuneration: {
			path: 'accountRemuneration',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		cards: {
			path: 'cards',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		comunications: {
			path: 'communications',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/communications-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/communications-api/v2',
				},
			},
		},
		reports: {
			path: 'reports',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/communications-api/v2',
				},
			},
		},
		reporting: {
			path: 'reporting',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/communications-api/v2',
				},
			},
		},
		loans: {
			path: 'loans',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/loans-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/loans-api/v2',
				},
			},
		},
		markets: {
			path: 'markets',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/markets-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/markets-api/v2',
				},
			},
		},
		mifid: {
			path: 'convenienceTest',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/mifid-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2',
				},
			},
		},
		savings: {
			path: 'savings',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/savings-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/savings-api/v2',
				},
			},
		},
		transfers: {
			path: 'transfers',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				delete: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		immediateTransfers: {
			path: '',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		beneficiaries: {
			path: 'beneficiaries',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				delete: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		language: {
			path: 'literales',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/literales-api/v2',
				},
			},
		},
		configuration: {
			path: 'configurations/default',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/configurations-api/v2',
				},
			},
		},
		login: {
			path: 'tokenjwt',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/login-api/v2',
				},
				get: {
					basepath: 'uat/canalcliente/login-api/v2',
				},
			},
		},
		logout: {
			path: 'logout',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/hbk-security-service-api/v2',
				},
			},
		},
		authenticate: {
			path: 'authenticate',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/hbk-security-service-api/v2',
				},
			},
		},
		contactInformation: {
			path: 'contactInformation',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
			},
		},
		refresh: {
			path: 'refresh',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/hbk-security-service-api/v2',
				},
			},
		},
		home: {
			path: 'home',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
			},
		},
		phoneAssignation: {
			path: 'PhoneAssignation',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
			},
		},
		investments: {
			path: 'investments',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
			},
		},
		investmentOperations: {
			path: 'investments/operations',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
			},
		},
		detailPreferences: {
			path: 'detailPreferences',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		updatePreferences: {
			path: 'updatePreferences',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		accountStatement: {
			path: 'accountStatement',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		ownershipCertificate: {
			path: 'ownershipCertificate',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		transfers2FM: {
			path: 'transfers2FM',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				delete: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		checkIban: {
			path: 'dataiban',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				delete: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		beneficiariesTransfers: {
			path: 'beneficiaries',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
				delete: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		portfolioPG: {
			path: '/home/portfolio',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/general-api/v2',
				},
			},
		},
		musicalWalletDetail: {
			path: 'getMusicalWalletDetail',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		bizumUserInfo: {
			path: 'getUserDataBizum',
			verbs: {
				get: {
					basepath: 'bizum/v2/users',
				},
			},
		},
		bizumSendPaymentOperation: {
			path: 'paymentOperation',
			verbs: {
				post: {
					basepath: 'bizum/v2/transfers',
				},
			},
		},
		bizumRequestPaymentOperation: {
			path: 'paymentRequest',
			verbs: {
				post: {
					basepath: 'bizum/v2/transfers',
				},
			},
		},
		analysisBizum: {
			path: 'analysis',
			verbs: {
				post: {
					basepath: 'bizum/v2/',
				},
			},
		},
		bizumONGList: {
			path: 'list',
			verbs: {
				get: {
					basepath: 'bizum/v2/ong',
				},
			},
		},
		entityUserInfo: {
			path: 'getUserData',
			verbs: {
				post: {
					basepath: 'bizum/v2/users',
				},
			},
		},
		bizumOperationsList: {
			path: 'list',
			verbs: {
				post: {
					basepath: 'bizum/v2/operations',
				},
			},
		},
		bizumCancelOperation: {
			path: 'cancelOperation',
			verbs: {
				post: {
					basepath: 'bizum/v2/transfers',
				},
			},
		},
		bizumRepaymentOperation: {
			path: 'repayment',
			verbs: {
				post: {
					basepath: 'bizum/v2/transfers',
				},
			},
		},
		bizumOTPGenerate: {
			path: 'generate',
			verbs: {
				post: {
					basepath: 'bizum/v2/otp',
				},
			},
		},
		bizumOTPValidate: {
			path: 'validate',
			verbs: {
				post: {
					basepath: 'bizum/v2/otp',
				},
			},
		},
		bizumOTPValidateAndPayOperation: {
			path: 'validateAndPayOperation',
			verbs: {
				post: {
					basepath: 'bizum/v2/otp',
				},
			},
		},
		bizumOTPValidateAndUnsubscribeUser: {
			path: 'validateAndUnsubscribeUser',
			verbs: {
				post: {
					basepath: 'bizum/v2/otp',
				},
			},
		},
		bizumLogin: {
			path: 'login',
			verbs: {
				post: {
					basepath: 'bizum/v2/session',
				},
			},
		},
		altaBizumLogin: {
			path: 'createUser',
			verbs: {
				post: {
					basepath: 'bizum/v2/users',
				},
			},
		},
		bajaBizumLogin: {
			path: 'unsubscribeUser',
			verbs: {
				post: {
					basepath: 'bizum/v2/users',
				},
			},
		},
		bizumSubscription: {
			path: 'suscriptions',
			verbs: {
				post: {
					basepath: 'bizum/v2',
				},
			},
		},
		bizumIDRequestToConsent: {
			path: 'id/requestToConsent',
			verbs: {
				get: {
					basepath: 'bizum/v2',
				},
				post: {
					basepath: 'bizum/v2',
				},
			},
		},
		bizumIDConsent: {
			path: 'id/consent',
			verbs: {
				post: {
					basepath: 'bizum/v2',
				},
			},
		},
		portfolio: {
			path: 'portfolios',
			verbs: {
				post: {
					basepath: 'users',
				},
			},
		},
		getInvestmentOrderList: {
			path: 'orderList',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		orderRelatedOperations: {
			path: 'orderRelatedOperations',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		walletHireResult: {
			path: 'getTest/',
			verbs: {
				post: {
					basepath: 'suitabilityTest',
				},
			},
		},
		walletHireDownload: {
			path: 'download',
			verbs: {
				post: {
					basepath: 'signContract',
				},
			},
		},
		walletHireInit: {
			path: 'initDigitalSign',
			verbs: {
				post: {
					basepath: 'signContract',
				},
			},
		},
		walletHireConfirm: {
			path: 'confirmDigitalSign',
			verbs: {
				post: {
					basepath: 'signContract',
				},
			},
		},
		investmentDetail: {
			path: 'investmentDetail',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		investmentComposition: {
			path: 'postPositions',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		investmentCompositionFunds: {
			path: 'postPositions',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		investmentChart: {
			path: 'postClientGraph',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		transferDetailPdf: {
			path: 'transferReceiptMYB',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		movementDetailPdf: {
			path: 'movementDetailOverview',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		movementsPdf: {
			path: 'movementOverview',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		movementsExcel: {
			path: 'exportMovements',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		suitabilityQuestion: {
			path: 'question',
			basepath: 'inversiones/v2/suitabilityTest',
			protocol: 'https',
			verbs: {
				post: {
					headers: {
						'Content-Type': 'application/json',
					},
				},
			},
		},
		suitabilityGetResult: {
			path: 'getResult',
			basepath: 'inversiones/v2/suitabilityTest',
			protocol: 'https',
			verbs: {
				post: {
					headers: {
						'Content-Type': 'application/json',
					},
				},
			},
		},
		suitabilitySetTest: {
			path: 'setTest',
			basepath: 'inversiones/v2/suitabilityTest',
			protocol: 'https',
			verbs: {
				post: {
					headers: {
						'Content-Type': 'application/json',
					},
				},
			},
		},
		suitabilityGetTest: {
			path: 'getTest',
			basepath: 'inversiones/v2/suitabilityTest',
			protocol: 'https',
			verbs: {
				post: {
					headers: {
						'Content-Type': 'application/json',
					},
				},
			},
		},
		mifidConvenienceTest: {
			path: 'convenienceTest',
			basepath: 'uat/canalcliente/mifid-api/v2',
			protocol: 'https',
			verbs: {
				get: {
					headers: {
						Accept: 'application/json',
					},
				},
			},
		},
		mifidQuestion: {
			path: 'question',
			basepath: 'uat/canalcliente/mifid-api/v2/convenienceTest',
			protocol: 'https',
			verbs: {
				get: {
					headers: {
						Accept: 'application/json',
					},
				},
				post: {
					headers: {
						Accept: 'application/json',
					},
				},
			},
		},
		mifidValidation: {
			path: 'validation',
			basepath: 'uat/canalcliente/mifid-api/v2/convenienceTest/question',
			protocol: 'https',
			verbs: {
				post: {
					headers: {
						Accept: 'application/json',
					},
				},
			},
		},
		mifidProduct: {
			path: 'product',
			basepath: 'convenienceTest',
			verbs: {
				get: {
					headers: {
						Accept: 'application/json',
					},
				},
			},
		},
		mailAttachment: {
			path: 'sendMailDocument',
			basepath: 'uat/canalcliente/ol-mailing/v2',
			verbs: {
				post: {
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				},
			},
		},
		radicalAccounts: {
			path: 'radicalAccounts',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		accountsAll: {
			path: 'accounts',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		wfg: {
			path: 'wfg',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/wfg-api/v2',
				},
			},
		},
		transferDetailResumePdf: {
			path: 'transferDetailOverview',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		transfersPdf: {
			path: 'transferOverview',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		transfersExcel: {
			path: 'exportTransfers',
			verbs: {
				get: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		changePassword: {
			path: 'changeUserPass2FM',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/login-api/v2',
				},
			},
		},
		changePasswordOTP: {
			path: 'changeUserPassConfirmation2FM',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/login-api/v2',
				},
			},
		},
		correspondence: {
			path: 'communications',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/communications-api/v2',
				},
			},
		},
		getTasksList: {
			path: 'getTasksList',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/communications-api/v2/tasks/',
				},
			},
		},
		getTasksDetail: {
			path: 'getTasksDetail',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/communications-api/v2/tasks/',
				},
			},
		},
		getTasksFile: {
			path: 'getTasksFile',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/communications-api/v2/tasks/',
				},
			},
		},
		bizumUpload: {
			path: 'upload',
			verbs: {
				post: {
					basepath: 'bizum/v2/content',
				},
			},
		},
		bizumDownload: {
			path: 'download',
			verbs: {
				post: {
					basepath: 'bizum/v2/content',
				},
			},
		},
		landing: {
			path: 'faqs',
			host: 'myinvuat.andbank.com',
			protocol: 'https',
			verbs: {
				get: {},
			},
		},
		pendingTasks: {
			path: 'getPendingTasks',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/communications-api/v2/tasks/',
				},
			},
		},
		requestCard: {
			path: 'cards/application',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		cardConfiguration: {
			path: "cards/configure",
			verbs: {
				get: {
					basepath: "uat/canalcliente/cards-api/v2"
				}
			}
		},
		requestInfoCard: {
			path: 'cards',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		requestCardAll: {
			path: 'cards',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		requestMovementsCard: {
			path: 'cards',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		requestLimitsCard: {
			path: 'cards/',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		sendMailCardInfo: {
			path: 'sendMailCardInfo',
			basepath: 'uat/canalcliente/ol-mailing/v2',
			verbs: {
				post: {
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				},
			},
		},
		userValid: {
			path: 'isUserValid',
			verbs: {
				get: {
					basepath: 'register/v2',
				},
			},
		},
		downloadCard: {
			path: 'requestCards/downloadContract',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		initSignContractCard: {
			path: 'requestCards/initSignContractCard',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		cardOTP: {
			path: 'requestCards/signContractCard',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		cardValidateOTP: {
			path: 'requestCards/validateSignContractCard',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		pinCard: {
			path: 'requestCards/pin',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2',
				},
			},
		},
		saveMifidQuestion: {
			path: 'question2FM',
			basepath: 'uat/canalcliente/mifid-api/v2/convenienceTest',
			verbs: {
				post: {
					headers: {
						Accept: 'application/json',
					},
				},
			},
		},
		confirmMifidQuestion: {
			path: 'question2FM/confirmation',
			basepath: 'uat/canalcliente/mifid-api/v2/convenienceTest',
			verbs: {
				post: {
					headers: {
						Accept: 'application/json',
					},
				},
			},
		},
		walletProfitability: {
			path: 'postProfitabilityMWR',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		prepareDigitalSignManagedPortfolio: {
			path: 'prepareDigitalSignManagedPortfolio',
			verbs: {
				post: {
					basepath: 'inversiones/v2/signContract',
				},
			},
		},
		initDigitalSign: {
			path: 'initDigitalSign',
			verbs: {
				post: {
					basepath: 'inversiones/v2/signContract',
				},
			},
		},
		confirmDigitalSign: {
			path: 'confirmDigitalSign',
			verbs: {
				post: {
					basepath: 'inversiones/v2/signContract',
				},
			},
		},
		inviteFriend: {
			path: 'generateFriendCode',
			withAuth: false,
			verbs: {
				post: {
					basepath: 'uat/canalcliente/altaCliente/v2',
				},
			},
		},
		validateBooking: {
			path: 'validateBooking',
			withAuth: false,
			verbs: {
				post: {
					basepath: 'uat/canalcliente/altaCliente/v2',
				},
			},
		},
		confirmBooking: {
			path: 'confirmBooking',
			withAuth: false,
			verbs: {
				post: {
					basepath: 'uat/canalcliente/altaCliente/v2',
				},
			},
		},
		startTransfer: {
			path: 'startTransfer',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		startTransferValidation: {
			path: 'validateTransfer',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		signTransfer: {
			path: 'signTransfer',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		startExternalTransfer: {
			path: 'requestProvision',
			verbs: {
				post: {
					basepath: 'inversiones/v2/portfolios',
				},
			},
		},
		startPermanentTransfer: {
			path: 'startPermanentTransfer',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		startPermanentTransferValidation: {
			path: 'validatePermanentTransfer',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		signPermanentTransfer: {
			path: 'signPermanentTransfer',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		requestCancellation: {
			path: 'requestCancellation',
			verbs: {
				post: {
					basepath: 'inversiones/v2/portfolios',
				},
				put: {
					basepath: 'inversiones/v2/portfolios',
				},
			},
		},
		refundWallet: {
			path: 'requestRefund',
			verbs: {
				post: {
					basepath: 'inversiones/v2/portfolios',
				},
				put: {
					basepath: 'inversiones/v2/portfolios',
				},
			},
		},
		fichaFondo: {
			path: 'getDocument',
			verbs: {
				get: {
					basepath: 'inversiones/v2/allfunds',
				},
			},
		},
		queryBeneficiaryClient: {
			path: 'consultarBeneficioClienteRadical',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/altaCliente/v2',
					protocol: 'https',
				},
			},
		},
		MutationBeneficiaryClientRegister: {
			path: 'altaBeneficioCliente',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/altaCliente/v2',
					protocol: 'https',
				},
			},
		},
		queryIsUserFF: {
			path: 'isUserFF',
			verbs: {
				get: {
					basepath: 'register/v2',
					protocol: 'https',
				},
			},
		},
		saveDocumentIdentity: {
			path: 'saveDocumentIdentity',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/ol-gestion-documental/v2',
					protocol: 'https',
				},
			},
		},
		saveDocumentTax: {
			path: 'saveDocumentFiscal',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/ol-gestion-documental/v2',
					protocol: 'https',
				},
			},
		},
		news: {
			path: 'news',
			host: 'myinvuat.andbank.com',
			protocol: 'https',
			verbs: {
				get: {},
			},
		},
		investmentFundsList: {
			path: 'listar',
			verbs: {
				post: {
					basepath: 'inversiones/v2/fondos',
				},
			},
		},
		investmentRegionsList: {
			path: 'obternerRegiones',
			verbs: {
				post: {
					basepath: 'inversiones/v2/fondos',
				},
			},
		},
		investmentManagersList: {
			path: 'obternerGestoras',
			verbs: {
				post: {
					basepath: 'inversiones/v2/fondos',
				},
			},
		},
		investmentValidarRad: {
			path: 'validarRad',
			verbs: {
				post: {
					basepath: 'inversiones/v2/fondos',
				},
			},
		},
		investmentAvailable: {
			path: 'clients',
			verbs: {
				get: {
					basepath: 'inversiones/v2',
				},
				post: {
					basepath: 'inversiones/v2',
				},
			},
		},
		contractFundsMYBPDF: {
			path: 'generateContractFundsMYB',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		startSignContractFundsMYB: {
			path: 'startSignContractFundsMYB',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		contratarFondosMYBPDF: {
			path: 'contratar',
			verbs: {
				post: {
					basepath: 'inversiones/v2/fondos',
				},
			},
		},
		investmentFundsDetail: {
			path: 'detallar',
			verbs: {
				post: {
					basepath: 'inversiones/v2/fondos',
				},
			},
		},
		requestOrderList: {
			path: 'orderList',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		requestPendingOrderList: {
			path: 'orders',
			verbs: {
				get: {
					basepath: 'inversiones/v2',
				},
				delete: {
					basepath: 'inversiones/v2',
				},
				post: {
					basepath: 'inversiones/v2',
				},
				put: {
					basepath: 'inversiones/v2',
				},
			},
		},
		getOrdersFundList: {
			path: 'orders',
			verbs: {
				get: {
					basepath: 'inversiones/v2',
				},
				delete: {
					basepath: 'inversiones/v2',
				},
			},
		},
		altaBeneficioClienteCodigo: {
			path: 'altaBeneficioClienteCodigo',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/altaCliente/v2',
					protocol: 'https',
				},
			},
		},
		userUSD: {
			path: 'isUserUSD',
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'register/v2',
					protocol: 'https',
				},
			},
		},
		requestHistoricFundList: {
			path: 'funds',
			verbs: {
				get: {
					basepath: 'inversiones/v2',
				},
			},
		},
		savingList: {
			path: 'savings',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/savings-api/v2',
				},
			},
		},
		savingListAll: {
			path: 'savings',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/savings-api/v2',
				},
			},
		},
		savingMYB: {
			path: 'savingsMYB',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/savings-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/savings-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/savings-api/v2',
				},
			},
		},
		requestLimitsCards: {
			path: 'limitsMYB',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2/cards',
				},
				// [DEPRECADO - ahora con firma OTP] post sustituido por requestLimitsCardConfirmation2FM (PUT limitsConfirmation2FM)
				// post: {
				// 	basepath: 'uat/canalcliente/cards-api/v2/cards',
				// },
			},
		},
		requestConfigurationCards: {
			path: 'configure',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2/cards',
				},
				// [DEPRECADO - ahora con firma OTP] post sustituido por requestConfigureCardConfirmation2FM (PUT configureConfirmation2FM)
				// post: {
				// 	basepath: 'uat/canalcliente/cards-api/v2/cards',
				// },
			},
		},
		requestGetOtpCancelCard: {
			path: 'cancel2FM',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/cards-api/v2/cards',
				},
			},
		},
		requestConfirmOtpCancelCard: {
			path: 'cancelConfirmation2FM',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/cards-api/v2/cards',
				},
			},
		},
		requestLimitsCard2FM: {
			path: 'limits2FM',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2/cards',
				},
			},
		},
		requestLimitsCardConfirmation2FM: {
			path: 'limitsConfirmation2FM',
			verbs: {
				put: {
					basepath: 'uat/canalcliente/cards-api/v2/cards',
				},
			},
		},
		requestConfigureCard2FM: {
			path: 'configure2FM',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/cards-api/v2/cards',
				},
			},
		},
		requestConfigureCardConfirmation2FM: {
			path: 'configureConfirmation2FM',
			verbs: {
				put: {
					basepath: 'uat/canalcliente/cards-api/v2/cards',
				},
			},
		},
		notifications: {
			path: 'notifications',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
			},
		},
		restGetDevices: {
			path: 'restGetDevices',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
			},
		},
		restGetRegisteredDevice: {
			path: 'restGetRegisteredDevice',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
			},
		},
		restRegisterDevice: {
			path: 'restRegisterDevice',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
			},
		},
		restUpdateTokenDevice: {
			path: 'restUpdateTokenDevice',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
			},
		},
		restUpdateFavouriteDevice: {
			path: 'restUpdateFavouriteDevice',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
			},
		},
		restDeleteDevice: {
			path: 'restDeleteDevice',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/notifications-api/v2',
				},
			},
		},
		isUserPromo: {
			path: 'isUserPromo',
			verbs: {
				get: {
					basepath: 'register/v2',
				},
			},
		},
		accountCurrencyActivation: {
			path: 'accountCurrencyActivation',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		sepaCountryISO3: {
			path: 'sepaCountryISO3',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		validateSecondTit: {
			path: 'validateSecondTit',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2/jointAccounts',
				},
			},
		},
		validateRestrictionActivation: {
			path: 'validateRestrictionActivation',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2/jointAccounts',
				},
			},
		},
		validateSignatureSign: {
			path: 'validateSignatureSign',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2/jointAccounts',
				},
			},
		},
		signatureResetOTP: {
			path: 'signatureReset',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2/jointAccounts',
				},
			},
		},
		createCaseConjunto: {
			path: 'createCaseConjunto',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2/jointAccounts',
				},
			},
		},
		performTaskCC: {
			path: 'performTaskCC',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
				},
			},
		},
		deleteCaseConjunto: {
			path: 'deleteCaseConjunto',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
				},
			},
		},
		getTaskInfoConjuntas: {
			path: 'getTaskInfoConjuntas',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
				},
			},
		},
		getCasesByRadicalPerson: {
			path: 'getCasesByRadicalPerson',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
				},
			},
		},
		transfersMYB: {
			path: 'transfersMYB',
			verbs: {
				put: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		transfersMYB2FM: {
			path: 'transfersMYB2FM',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		marketCurrencyMYB: {
			path: 'marketCurrencyMYB',
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/transfers-api/v2',
				},
			},
		},
		getCaseState: {
			path: 'getCaseState',
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/accounts-api/v2/jointAccounts',
				},
			},
		},
		generateContractsJointAccount: {
			path: 'generateContractsJointAccount',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		requestVideoScanInfo: {
			path: 'videoscan',
			withAuth: false,
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		requestVideoScanAuthorization: {
			path: 'videoscan.request',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
				put: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		electronicIDScanScript: {
			path: '',
			withAuth: false,
			verbs: {
				get: {
					// host: 'etrust-sandbox.electronicid.eu/js/videoid-3.x/videoid.js',
					host: 'etrust-live.electronicid.eu/js/videoid-3.x/videoscan.js',
					protocol: 'https',
				},
			},
		},
		generateContractsMinorAccount: {
			path: 'generateContractsMinorAccount',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		getContractBase64: {
			path: 'getContractBase64',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		minorAccounts: {
			path: 'minorAccounts',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
				put: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		altaUserMenorSIAGenerateOTP: {
			path: 'generateOTP',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2/altaUserMenorSIA',
				},
			},
		},
		altaUserMenorSIAValidateOTP: {
			path: 'validateOTP',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2/altaUserMenorSIA',
				},
			},
		},
		analysisPrevious: {
			path: 'previous',
			verbs: {
				post: {
					basepath: 'bizum/v2/analysis',
				},
			},
		},
		confirmPaymentRequest: {
			path: 'confirmPaymentRequest',
			verbs: {
				post: {
					basepath: 'bizum/v2/transfers',
				},
			},
		},
		appCleanCache: {
			path: 'cleanCache',
			verbs: {
				put: {
					basepath: 'inversiones/v2/sso',
				},
			},
		},
		insurance: {
			path: 'seguros',
			verbs: {
				get: { basepath: 'uat/canalcliente/assurance-api/v2' },
				post: { basepath: 'uat/canalcliente/assurance-api/v2' },
				put: { basepath: 'uat/canalcliente/assurance-api/v2' },
			},
		},
		personalFormsKYC: {
			path: 'kyc',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		personalFormsConvenienceTest: {
			path: 'convenienceTest',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/mifid-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2',
				},
			},
		},
		personalFormsSuitabilityTest: {
			path: 'suitabilityTest',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/mifid-api/v2',
				},
			},
		},
		suitabilityQuestionv2: {
			path: 'question',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2/suitabilityTest',
				},
			},
		},
		validationSuitabilityTest: {
			path: 'validation',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2/suitabilityTest/question',
				},
			},
		},
		question2FMSuitabilityTest: {
			path: 'question2FM',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2/suitabilityTest',
				},
			},
		},
		confirmationSuitabilityTest: {
			path: 'confirmation',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2/suitabilityTest/question2FM',
				},
			},
		},
		confirmationSuitabilityTestNo2fm: {
			path: 'confirmation',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2/suitabilityTest/question',
				},
			},
		},
		saveKYC2FM: {
			path: 'saveKYC2FM',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2/kyc',
				},
			},
		},
		saveKYC2FMConfirm: {
			path: 'saveKYC2FMConfirm',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/mifid-api/v2/kyc',
				},
			},
		},
		previousQuestionsKYC: {
			path: 'kyc',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/mifid-api/v2',
				},
			},
		},
		getDatosCliente: {
			path: 'getDatosCliente',
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/accounts-api/v2',
					protocol: 'https',
				}
			}
		},
		depositDetail: {
			path: 'detail',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/savings-api/v2/deposits',
				},
			},
		},
		walletProfitabilityCarteras: {
			path: 'postProfitabilityMWRCarteras',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		minorAccountsV2: {
			path: 'minorAccounts',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		validate18Years: {
			path: 'validate18Years',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2/minorAccounts',
				}
			},
		},
		createCaseToStandar: {
			path: 'createCaseToStandar ',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				}
			},
		},

		obtenerCarteraPosicion: {
			path: 'obtenerCarteraPosicion',
			verbs: {
				post: {
					basepath: 'inversiones/v2/basicOperations',
				},
			},
		},
		peticionesCarteras: {
			path: 'peticionesCarteras',
			verbs: {
				get: {
					basepath: 'inversiones/v2/portfolios',
				},
			},
		},
		fiscalDocumentPDF: {
			path: "fiscalDocument",
			verbs: {
				get: {
					basepath: "uat/canalcliente/communications-api/v2"
				},
				post: {
					basepath: "uat/canalcliente/communications-api/v2"
				}
			}
		},
		taxDocumentYears: {
			path: "taxDocumentYears",
			verbs: {
				get: {
					basepath: "uat/canalcliente/communications-api/v2"
				}
			}
		},
		avisoCliente: {
			path: "api",
			verbs: {
				get: {
					basepath: "uat/canalcliente/appian-web-api/v2"
				},
				post: {
					basepath: "uat/canalcliente/appian-web-api/v2"
				}
			}
		},
		signedDocuments: {
			path: "signedDocuments",
			verbs: {
				get: {
					basepath: "uat/canalcliente/general-api/v2"
				}
			}
		},
		validateFriendCode: {
			path: 'validateFriendCode',
			withAuth: false,
			verbs: {
				post: {
					basepath: 'uat/canalcliente/altaCliente/v2',
				},
			},
		},
		bookingFriendCode: {
			path: 'bookingFriendCode',
			withAuth: false,
			verbs: {
				post: {
					basepath: 'uat/canalcliente/altaCliente/v2',
				},
			},
		},
		cryptos: {
			path: "cryptos",
			verbs: {
				get: {
					basepath: "inversiones/v2"
				},
				post: {
					basepath: "inversiones/v2"
				},
				put: {
					basepath: "inversiones/v2"
				}
			}
		},
		mybpdf: {
			path: "MYB",
			verbs: {
				post: {
					basepath: "inversiones/v2"
				}
			}
		},
		refundWalletTotal: {
			path: 'requestRefundTotal',
			verbs: {
				post: {
					basepath: 'inversiones/v2/portfolios',
				},
				put: {
					basepath: 'inversiones/v2/portfolios',
				},
			},
		},
		checkContract: {
			path: "checkContract",
			verbs: {
				get: {
					basepath: "register/v2"
				}
			}
		},
		accountRequestCancellation: {
			path: "requestCancellation",
			verbs: {
				post: {
					basepath: "uat/canalcliente/accounts-api/v2"
				}
			}
		},
		checkFF: {
            path: "checkFF",
            verbs: {
                get: {
                	basepath: "register/v2"
                }
            }
        },
		expiredDocumentation: {
            path: "documentation/expired",
            verbs: {
                post: {
                	basepath: "uat/canalcliente/accounts-api/v2"
                }
            }
        },
		restModifyFavDevice: {
			path: "changeFavoriteDevice2FM",
			verbs: {
				get: {
					basepath: "inversiones/v1/device"
				},
				post: {
					basepath: "inversiones/v1/device"
				}
			}
		},
		restConfirmModifyFavDevice: {
			path: "changeFavoriteDeviceConfirm2FM",
			verbs: {
				get: {
					basepath: "inversiones/v1/device"
				},
				post: {
					basepath: "inversiones/v1/device"
				}
			}
		},
		restConfirmDeleteDevice2FM: {
			path: "deleteDeviceConfirm2FM",
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'inversiones/v2/device',
					protocol: 'https'
				}
			}
		},
		restDeleteDevice2FM: {
			path: "deleteDevice2FM",
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'inversiones/v2/device',
					protocol: 'https'
				}
			}
		},
		requestCards: {
			path: "requestCards",
			verbs: {
				get: {
					basepath: "uat/canalcliente/cards-api/v2"
				},
				post: {
					basepath: "uat/canalcliente/cards-api/v2"
				}
			}
		},
		identificationDisclamer: {
			path: '1.0.2',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/disclaimer-versionado/v2/disclaimer',
					protocol: 'https',
				},
			},
		},
		personalDataDisclamer: {
			path: '1.0.2.4',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/disclaimer-versionado/v2/disclaimer',
					protocol: 'https',
				},
			},
		},
		generateContractsAutonomo: {
			path: 'generateContractsAutonomo',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'inversiones/v2/basicOperations',
					protocol: 'https',
				},
			},
		},
		validateNrtComercio: {
			path: 'validateNrtComercio',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/accounts-api/v2/autonomos',
					protocol: 'https',
				},
			},
		},
		validateNRTPassport: {
            path: "validateNRTPassport",
            verbs: {
                post: {
                    basepath: 'inversiones/v2/basicOperations',
                }
            }
        },
		comercioAutonomos: {
			path: 'comercio',
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/accounts-api/v2/autonomos',
					protocol: 'https',
				},
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/accounts-api/v2/autonomos',
					protocol: 'https',
				},
				put: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/accounts-api/v2/autonomos',
					protocol: 'https',
				},
			},
		},
		exchange: {
            path: "exchange",
            verbs: {
                get: {
                    basepath: 'inversiones/v2',
                }
            }
		},
		accountsLimits: {
            path: 'accountsLimits',
            verbs: {
                get: {
                    basepath: 'uat/canalcliente/accounts-api/v2',
                },
            },
        },
        accountsLimits2FM: {
            path: 'accountsLimits/initUpdate',
            verbs: {
                get: {
                    basepath: 'uat/canalcliente/accounts-api/v2',
                },
            },
        },
        accountsLimitsConfirmation2FM: {
            path: 'accountsLimits/confirmUpdate',
            verbs: {
                put: {
                    basepath: 'uat/canalcliente/accounts-api/v2',
                },
            },
        },
		receiptRefund2FM: {
			path: 'receipt-refund/otp',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		receiptRefundConfirmation2FM: {
			path: 'receipt-refund/request/send',
			verbs: {
				post: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
		receiptRefundObtain: {
			path: 'receipt-refund/obtain',
			verbs: {
				get: {
					basepath: 'uat/canalcliente/accounts-api/v2',
				},
			},
		},
	},
};

// Enlaces externos (uno por idioma) a las bases legales de la promoción de cuenta remunerada (configurable por config map, campo `promo3legalurl`)
export const PROMO3_LEGAL_TERMS_URLS: Record<string, string> =
	config.promo3legalurl ?? {};

export { config };